import { ThemeProvider } from "@material-ui/core/styles";
import moment from "moment";
import Moment from "moment-timezone";
import React, { useEffect, useState, useReducer, useImperativeHandle } from "react";
import { Redirect, Route, Switch, useHistory, useLocation } from "react-router-dom";
import AccentsAndDialects from "../src/components/core/AccentsAndDialects/AccentsAndDialects";
import CultureNotesLocation from "../src/components/core/CultureNotesLocation/CultureNotesLocation";
import CultureNotesTopic from "../src/components/core/CultureNotesTopic/CultureNotesTopic";
import "./App.scss";
import CultureNotes from "./components/core/CultureNotes/CultureNotes";
import EmailTemplates from "./components/core/EmailTemplates/EmailTemplates";
import HomePage from "./components/core/HomePage/HomePage";
import MySchedulePage from "./components/core/MyScheduleComponentBlock/MySchedulePage";
import ProgressPage from "./components/core/ProgressPage/ProgressPage";
import ProductSessionsBlock from "./components/core/MyScheduleComponentBlock/ProductSessionsBlock";
import SessionReport from "./components/core/SessionReportBlock/SessionReport";
import FooterComponentBlock from "./components/shared/FooterComponent/FooterComponentBlock";
import Header from "./components/shared/Header/Header";
import MaintenancePage from "./components/shared/MaintenancePage/MaintenancePage";
import PageNotFound from "./components/shared/PageNotFoundPage/PageNotFound";
import RenewalIntercept from "./components/shared/RenewalIntercept/RenewalIntercept";
import { getCookieValue, setCookies } from "./cookieHelper";
import { useSelector, useDispatch } from "react-redux";
import INTLProvider from "./i18n/provider";
import theme from "./theme";
import { languageList } from "../src/i18n/locales";
import ReactGA from "react-ga";
import Toaster from "./components/shared/Toaster/Toaster";
import allActions from "./redux/actions";
import Logout from "./components/shared/Logout/Logout";
import LearnerProfile from "./components/shared/LearnerProfile/LearnerProfile";
import { allEnglishProductIds } from "./globalConstants";
import VideoPlayer from "./components/shared/VideoPlayer/VideoPlayer";
import Twt from "./components/core/Twt/Twt";
import { isEmailBitOn } from "./utils/FeatureBitCheck";

declare global {
  interface Window {
    Intercom: any;
  }
  interface Window {
    liveagent: any;
  }
  interface Window {
    intercomSettings: any;
  }
}
window.Intercom = window.Intercom || {};
window.intercomSettings = window.intercomSettings || {};
window.liveagent = window.liveagent || {};


const App = (props: any) => {
  const history = useHistory();
  const allInfo = useSelector((state: any) => state);
  const dispatch = useDispatch();
  let [currentuLang, setcurrentuLang] = useState("EN");
  let [languageSet, setlanguageSet] = useState(false);
  const GALocation = useLocation();
  const [maintenance] = useState(JSON.parse(process.env.REACT_APP_MAINTENANCE_COMPONENT || "[]") || []);
  const [duration] = useState(JSON.parse(process.env.REACT_APP_MAINTENANCE_DURATION || "[]") || []);
  const [isRenewal, setRenewal] = useState(false);
  const [isEnglishUser, setIsEngUser]= useState(true);

  if (!!!getCookieValue("ulang")) {
    setCookies(`ulang`, "EN");
  } else {
    if (!languageSet) {
      setlanguageSet(true);
    }
  }

  const isNewsfeedTimezoneBlocked = async () => {
    const blockedCountryList = ['CN'];
    const blockedTzList = ["Asia/Zhejiang", "Asia/Yunnan", "Asia/Xinjiang", "Asia/Tibet", "Asia/Tianjin", "Asia/Sichuan", "Asia/Shanxi", "Asia/Shanghai", "Asia/Shandong", "Asia/Shaanxi", "Asia/Qinghai", "Asia/Ningxia Hui Autonomous Region", "Asia/Liaoning", "Asia/Jilin", "Asia/Jiangxi", "Asia/Jiangsu", "Asia/Inner Mongolia", "Asia/Hunan", "Asia/Hubei", "Asia/Henan", "Asia/Heilongjiang", "Asia/Hebei", "Asia/Hainan", "Asia/Guizhou", "Asia/Guangxi", "Asia/Guangdong", "Asia/Gansu", "Asia/Fujian", "Asia/Chongqing", "Asia/Beijing", "Asia/Anhui"];    
    await dispatch(allActions.commonActions.setIsNewsfeedTzBlocked(!!allInfo.peopleInformation.data.getpeopleInformation.country.includes(blockedCountryList) || !!blockedTzList.includes(Moment.tz.guess(true))));
  }

  const afterGetLearnerInfo = (resp: any) => {
    isNewsfeedTimezoneBlocked();
    //const { firstName, lastName, email, createdDate,username, edgeUid, language, country} = resp.data.getpeopleInformation;
    
    // if (window.Intercom && window.Intercom.booted) {
    //   const intercomConfig = {
    //     app_id: process.env.REACT_APP_INTERCOMAPPID || 0,
    //     name: `${firstName} ${lastName}`,
    //     email: "'" + email + "'",
    //     created_at: "" + createdDate + "",
    //   };
      // window.Intercom("boot", intercomConfig);
    //}
  };

  const onUnload = (e: any) => {
    if (!!!allInfo.common.isLoading) {
      if (!!!allInfo.common.isUserAuthenticated) {
        e.preventDefault();
        if (window.location.href !== `${window.location.origin}/`) {
          if (window.location.href.search(/redirectUrl/gi) === -1) {
            sessionStorage.setItem("rURL", window.location.pathname);
            sessionStorage.setItem(
              "rURLf",
              `${window.location.origin}/?redirectUrl=${encodeURIComponent(window.location.origin)}${encodeURIComponent(
                sessionStorage.getItem("rURL") || ""
              )}`
            );
          }
        } else {
          sessionStorage.removeItem("rURL");
          sessionStorage.removeItem("rURLf");
          sessionStorage.removeItem("courseId");
        }
      }
    }
  };

  const getRenewalData = async (userId: number) => {
    if(!!!allInfo.renewalInformation.data){
      await dispatch(allActions.renewalInformationAction.getStoreRenewalInfo(userId));
    }    
  };
  async function checkForRenewal(pinfo: any, renewalInfo : any) {
    const isRenwalFeatureBitOn : any = isEmailBitOn(allInfo.peopleInformation.data.getpeopleInformation, "Renewal Email/Reminders/Intercept");
    if(isRenwalFeatureBitOn)
    {
    for (let i: number = 0; i < pinfo.license.length; i++) {
      if (((pinfo.license[i].endDate - Moment().unix()) / 3600) <= 720 && sessionStorage.getItem("RenwalIntercept")!=="skip") {
     
            let latestDate: any;
            if ((!!(renewalInfo.getRenewalDate))) {
              const dataExtract =  JSON.parse(renewalInfo.getRenewalDate);
              const renewDataArray = dataExtract.renewEmails;
              latestDate =  renewDataArray.map(function(e : any) { return e.RenewDate; }).sort().reverse()[0];
            }
            if (!!!(latestDate) || ((Moment().unix()-((new Date(latestDate).getTime()/1000))) / 3600) > 720) {
              sessionStorage.setItem("RenwalIntercept","true");
              setRenewal(true);
            
              if(!!!allInfo.isLoading  && !!!allInfo.common.isLoading)
              {
                await dispatch(allActions.commonActions.setRenewalInterceptRequired(true));
              }
              sessionStorage.setItem("RenewalEndDate",pinfo.license[i].endDate);
            }
            else
            {
              setRenewal(false);
              if(!!!allInfo.isLoading && !!!allInfo.common.isLoading )
              {
                await dispatch(allActions.commonActions.setRenewalInterceptRequired(false));
              }
              sessionStorage.setItem("RenwalIntercept","false");
            }
      }
      else 
      {
        if(!!!allInfo.isLoading && !!!allInfo.commonActions && !!!allInfo.common.isLoading )
        {
          await dispatch(allActions.commonActions.setRenewalInterceptRequired(false));
        }
      }
    }
  }
  else{
    await dispatch(allActions.commonActions.setRenewalInterceptRequired(false));
  }
  }
  
  useEffect(() => {
    if (!!!allInfo.renewalInformation.isLoading) {
      if (!!allInfo.renewalInformation.data && !!allInfo.peopleInformation.data) {
        checkForRenewal(allInfo.peopleInformation.data.getpeopleInformation,allInfo.renewalInformation.data);        
      }
    }
  }, [allInfo]);

  useEffect(() => {
    triggerGlobalToaster();
  }, [allInfo.toaster.showToast]);

  // useEffect(()=>{
  //   window.addEventListener("beforeunload", onUnload);
  // },[]);
  useEffect(() => {
    updatePageTitle();
    window.scrollTo(0,0)
    if (!!allInfo.jwkPublicKey && !!allInfo.jwkPublicKey.data) {
      props.jwtValidation(getCookieValue(`${process.env.REACT_APP_ENV}IdToken`), allInfo.jwkPublicKey.data.keys[0]);
    }
  }, [window.location.href]);
  useEffect(() => {
    if (
      !!!allInfo.common.isLoading &&
      !!!allInfo.peopleInformation.isLoading &&
      !!!allInfo.learnerTasks.isLoading &&
      !!!allInfo.portalLogin.isLoading &&
      !!!allInfo.jwkPublicKey.isLoading &&
      !!!allInfo.renewalInformation.isLoading
    ) {
      if (!!!allInfo.peopleInformation.isFailed && !!allInfo.peopleInformation.data) {
        afterGetLearnerInfo(allInfo.peopleInformation);
        if(!!!allInfo.renewalInformation.isFailed)
        {
          getRenewalData(Number(allInfo.common.leuId));
        }
        else
        {
           dispatch(allActions.commonActions.setRenewalInterceptRequired(false));
        }
      }
     
    }
  }, [allInfo.common, allInfo.peopleInformation, allInfo.learnerTasks, allInfo.portalLogin, allInfo.jwkPublicKey, allInfo.renewalInformation, allInfo.common.isRenewalInterceptRequired]);
  
  useEffect(()=> {
    if (
      !!!allInfo.common.isLoading &&
      !!!allInfo.peopleInformation.isLoading &&
      !!allInfo.peopleInformation.data
    ) {
      isEnglishFeatureRequired(allInfo.peopleInformation.data.getpeopleInformation.license);
    }
  },[ allInfo.peopleInformation]);
  useEffect(() => {
    setcurrentuLang(getCookieValue("ulang") || "EN");
    const selectedLang = getCookieValue("ulang") || "EN";
    languageList.forEach((language: any) => {
      if (language.locale === selectedLang) {
        language.isSelected = true;
      } else if (language.isSelected) {
        language.isSelected = false;
      }
    });
  }, [languageSet]);

  const [toastOptions, settoastOptions] = useReducer((state: any, newState: any) => ({ ...state, ...newState }), {
    toastOpen: false,
    toastSeverity: "error",
    toastMessageKey: "",
  });

  const handleToastOptionsDirect = (name: string, val: any) => {
    settoastOptions({ [name]: val });
  };

  const toasterHandle = (open: boolean, severity: string, messageKey: string) => {
    handleToastOptionsDirect("toastSeverity", severity);
    handleToastOptionsDirect("toastMessageKey", messageKey);
    handleToastOptionsDirect("toastOpen", !!open);
    if (!!!open) {
      handleAfterToastClose();
    }
  };

  const updatePageTitle = () => {
    let currentFullPath: string = "";
    if (window.location.href.search(/redirectUrl/gi) === -1) {
      currentFullPath = window.location.pathname;
      if (currentFullPath.length === 1 && currentFullPath === "/") {
        if (!!!allInfo.common.isLoading) {
          if (allInfo.common.isUserAuthenticated) {
            document.title = "Halo - Home";
          } else {
            document.title = "Halo";
          }
        }
      }
      if (currentFullPath.indexOf("/welcome") >= 0) {
        document.title = "Halo - Welcome";
      }
      if (currentFullPath.indexOf("/profile") >= 0) {
        document.title = "Halo - Profile";
      }
      if (currentFullPath.indexOf("/progress") >= 0) {
        document.title = "Halo - Progress";
      }
      if (currentFullPath.indexOf("/schedule") >= 0) {
        document.title = "Halo - Schedule";
      }
      if (currentFullPath.indexOf("/culturenotes") >= 0) {
        document.title = "Halo - Culture Notes";
      }
      if (currentFullPath.indexOf("/emailtemplates") >= 0) {
        document.title = "Halo - Email Templates";
      }
      if (currentFullPath.indexOf("/accentsanddialects") >= 0) {
        document.title = "Halo - Accents and Dialects";
      }
      if (currentFullPath.indexOf("/maintenance") >= 0) {
        document.title = "Halo - Maintenance";
      }
      if (currentFullPath.indexOf("/renewalintercept") >= 0) {
        document.title = "Halo - Renewal Intercept";
      }
    } else {
      document.title = "Halo";
    }
  };

  const performOnEveryPage = () => {
    if(!!!allInfo.announcements.data && !!allInfo.common.leuId && !!!allInfo.announcements.isLoading && !!!allInfo.announcements.isFailed){
      dispatch(allActions.announcementsAction.getAnnouncements(allInfo.common.leuId));
   }
    updatePageTitle();
    let isAuthenticatedNow = false;
    if (!!!allInfo.common.isLoading) {
      if (allInfo.common.isUserAuthenticated) {
        isAuthenticatedNow = true;
        profileIncomplettionRedirection();
      }
    
      if (
        window.location.pathname !== "/welcome" &&
        !!!allInfo.common.isLoading && allInfo.common.isManagerEmailRequired===true
        && !!!allInfo.common.managerEmail
      ) {
        sessionStorage.setItem("urlRedirect", window.location.pathname);
        history.push("/");
      } else if (window.location.pathname !== "/welcome") {
        if (!!!allInfo.common.isLoading && !! allInfo.peopleInformation.data) {   
          dispatch(allActions.commonActions.setManagerEmail(allInfo.peopleInformation.data.getpeopleInformation.managerEmail));
          const isManagerEmailRequired : any = isEmailBitOn(allInfo.peopleInformation.data.getpeopleInformation, "Manager");
          dispatch(allActions.commonActions.setManagerEmailRequired(isManagerEmailRequired));
          }
        profileIncomplettionRedirection();
      } else if (window.location.pathname === "/welcome") {
        dispatch(allActions.commonActions.setManagerEmailRequired(false));
        sessionStorage.setItem("skipManagerEmail", "true");
      }
    }
    return isAuthenticatedNow;
  };

  const initGoogleAnalytics = (resp: any) => {
    if (resp.data.getpeopleInformation.serviceConfiguration.features.substring(84, 85) === "1") {
      if (window.location.pathname === "/") {
        const trackingId: string = process.env.REACT_APP_GA_TRACKING_ID || "";
        ReactGA.initialize(trackingId);
        const url = window.location.pathname + "home";
        ReactGA.set({ page: url });
        ReactGA.pageview(url);
      } else {
        const trackingId: string = process.env.REACT_APP_GA_TRACKING_ID || "";
        ReactGA.initialize(trackingId);
        const url = window.location.pathname;
        ReactGA.set({ page: url });
        ReactGA.pageview(url);
      }
    }
  };

  useEffect(() => {
    if (!!!allInfo.peopleInformation.isLoading && !!!allInfo.peopleInformation.isFailed && !!allInfo.peopleInformation.data) {
      initGoogleAnalytics(allInfo.peopleInformation);
    }
  }, [GALocation]);

  const shouldRedirectToProfile = (calledFromSlash?: boolean) => {        
    let isAuthed = false;
    if (allInfo.learnerTasks) {
      if (allInfo.learnerTasks.data) {
        isAuthed = true;
        let filteredResp = [],
          respData = [];
        const resp = allInfo.learnerTasks;
        respData = resp.data.getLearnerTasks ? resp.data.getLearnerTasks : [];
        if (respData.length > 0) {
          filteredResp = respData.filter((taskObj: any) => {
            return `${taskObj.taskid}` === "1";
          });
        }
        if (filteredResp && filteredResp.length > 0 && filteredResp[0].status) {
          sessionStorage.setItem("pComp", "true");
          sessionStorage.setItem("skipManagerEmail","false");
        } else {
          sessionStorage.setItem("skipManagerEmail","true");
          sessionStorage.removeItem("pComp");
          if (isAuthed) {
            if (window.location.pathname !== "/welcome") {
              history.push("/welcome");
            }            
          }
        }
      } else {
        if (!!allInfo.learnerTasks.isFailed) {
          sessionStorage.removeItem("redDone");
          sessionStorage.removeItem("pComp");
        }
      }
    }
  };

  const profileIncomplettionRedirection = () => {
    if (allInfo.learnerTasks && !!!allInfo.learnerTasks.isLoading) {
      if (allInfo.learnerTasks.data) {
        let redDone = sessionStorage.getItem("redDone") || null;
        let pComp = sessionStorage.getItem("pComp") || null;
        if (!redDone) {
          let filteredResp = [],
            respData = [];
          const resp = allInfo.learnerTasks;
          respData = resp.data.getLearnerTasks ? resp.data.getLearnerTasks : [];
          if (respData.length > 0) {
            filteredResp = respData.filter((taskObj: any) => {
              return `${taskObj.taskid}` === "1";
            });
          }
          sessionStorage.removeItem("redDone");
          if (filteredResp && filteredResp.length > 0 && filteredResp[0].status) {
            sessionStorage.setItem("pComp", "true");
            if (window.location.pathname === "/welcome") {        
              if(!!!allInfo.learnerTasks.isLoading && !!allInfo.learnerTasks.data && !!!allInfo.peopleInformation.isLoading && !!allInfo.peopleInformation.data){
                history.push("/");
              }              
            }
          } else {
            sessionStorage.removeItem("pComp");
            if (window.location.pathname !== "/welcome") {
              history.push("/welcome");
            }            
          }
          shouldRedirectToProfile();
        } else {
          if (!!pComp) {
            if (window.location.pathname === "/welcome") {
              history.push("/");
            }
          }
          if (window.location.pathname !== "/welcome") {
            if (!!!pComp) {
              history.push("/welcome");
            }
          }
        }
      } else {
        if (!!allInfo.learnerTasks.isFailed) {
          sessionStorage.removeItem("redDone");
          sessionStorage.removeItem("pComp");
          shouldRedirectToProfile();
        }
      }
    }
  };

  const languageChange = async (lang?: string) => {
    if (!!lang) {
      setCookies(`ulang`, `${lang}`);
      setcurrentuLang(lang);
      await dispatch(allActions.commonActions.setLanguage(lang));
      languageList.forEach((language: any) => {
        if (language.locale === lang) {
          language.isSelected = true;
        } else if (language.isSelected) {
          language.isSelected = false;
        }
      });
    }
  };

  const triggerGlobalToaster = () => {
    if (allInfo.toaster.showToast) {
      toasterHandle(allInfo.toaster.showToast, allInfo.toaster.toastSeverity, allInfo.toaster.toastTransMessage);
    }
  };

  const handleAfterToastClose = async () => {
    await dispatch(allActions.toasterActions.resetToastMessage(false, "error", "message_errorDefault"));
  };

  const redirectHandle = () => {
    if((window.location.href !== `${window.location.origin}/`)){
      if((window.location.href.search(/redirectUrl/gi) === -1) && (window.location.href.search(/logout/gi) === -1)){            
        window.location.href = `${process.env.REACT_APP_SSO_LOGIN_URL}/?redirectUrl=${encodeURIComponent(window.location.href)}`;
      }
    } else {          
      window.location.href = `${process.env.REACT_APP_SSO_LOGIN_URL}`;          
    }
  }

  const shouldRedirectToSlash = () => {
    if (!!!allInfo.common.isLoading) {
      if (window.location.href !== `${window.location.origin}/`) {
        if (!!!allInfo.common.isLoading) {
          if (!!!props.isAuthenticating && !!!allInfo.common.isUserAuthenticated) {
            sessionStorage.setItem("apRedURL", window.location.pathname);
            redirectHandle();
            // return <Redirect to="" />;
          }
        }
      } else {
        if (!!!allInfo.common.isLoading) {
          if (!!!props.isAuthenticating && !!!allInfo.common.isUserAuthenticated) {
            redirectHandle();
            return <Redirect to="" />;
          }
        }
      }
    }
  };
  const isEnglishFeatureRequired= (license : any)=> {
    setIsEngUser( license.some((licenseList: any)=> allEnglishProductIds.indexOf(licenseList.productId) >= 0));
  };
  return (
    <ThemeProvider theme={theme}>
      <INTLProvider locale={currentuLang}>
        <div className="App">
         { window.location.pathname !== "/virtualclassroom" && <Header lChange={languageChange} currentLang={currentuLang} authProps={{ ...props }} isRenewal={isRenewal} setRenewal={setRenewal} isEnglishUser={!!isEnglishUser}/> }
          <Toaster
            open={toastOptions.toastOpen}
            severity={toastOptions.toastSeverity}
            toasterClosed={toasterHandle}
            messageKey={toastOptions.toastMessageKey}
          />
          <Switch>
            {maintenance.length > 0 &&
              maintenance[0] !== "" &&
              maintenance.map((path: any, key: number) => {
                return (
                  (duration[key] === "" ||
                    (moment.utc(duration[key].split("/")[0], "YYYY-MM-DD HH:mm").unix() <= Moment().unix() &&
                      moment.utc(duration[key].split("/")[1], "YYYY-MM-DD HH:mm").unix() >= Moment().unix())) && (
                    <Route
                      path={"/" + path}
                      render={() =>
                        performOnEveryPage() ? (
                          <MaintenancePage
                            maintenanceMins={
                              duration[key] === ""
                                ? ""
                                : (moment.utc(duration[key].split("/")[1], "YYYY-MM-DD HH:mm").unix() -
                                    Moment().unix()) /
                                  60
                            }
                          />
                        ) : (
                          <Redirect to="/" />
                        )
                      }
                    />
                  )
                );
              })}

            <Route path="/home">
              <HomePage authProps={{ ...props }} isEnglishUser={!!isEnglishUser}/>
            </Route>
            <Route path="/logout">
              <Logout authProps={{ ...props }} />
            </Route>
            <Route
              path="/schedule/:courseid"
              render={() =>
                performOnEveryPage() ? <ProductSessionsBlock></ProductSessionsBlock> : shouldRedirectToSlash()
              }
            />
            <Route
              path="/schedule"
              render={() => (performOnEveryPage() ? <MySchedulePage></MySchedulePage> : shouldRedirectToSlash())}
            />
            <Route
              path="/progress/:paramProdID?"
              render={() => (performOnEveryPage() ? <ProgressPage></ProgressPage> : shouldRedirectToSlash())}
            />
            <Route
              path="/sessionreport/:sessionid"
              render={() => (performOnEveryPage() ? <SessionReport></SessionReport> : shouldRedirectToSlash())}
            />
            <Route
              path="/profile"
              render={() =>
                performOnEveryPage() ? <LearnerProfile></LearnerProfile> : shouldRedirectToSlash()
              }
            />
            <Route
              path="/welcome"
              render={() =>
                performOnEveryPage() ? <LearnerProfile></LearnerProfile> : shouldRedirectToSlash()
              }
            />
            <Route
              path="/maintenance"
              render={() => (performOnEveryPage() ? <MaintenancePage /> : shouldRedirectToSlash())}
            />
            <Route
              path="/renewalintercept"
              render={() => (performOnEveryPage() ? <RenewalIntercept></RenewalIntercept> : shouldRedirectToSlash())}
            />
             {!!sessionStorage.getItem("isDemoUser") && <Route
              path="/virtualclassroom"
              render={() => (performOnEveryPage() ? <div className="PageContainerBlock"><VideoPlayer source={"../videos/virtualclassroom.mp4"} isplaying ={true} width={'100%'} height={'100%'} controls={true}></VideoPlayer> </div>: shouldRedirectToSlash())}
            />}
            <Route
              exact
              path="/"
              render={() => {
                shouldRedirectToProfile(true);
                return <HomePage authProps={{ ...props }} isEnglishUser={!!isEnglishUser}/>;
              }}
            />
              { !!isEnglishUser &&
              <React.Fragment>
                <Switch>
            <Route
              path="/accentsanddialects"
              render={() =>
                performOnEveryPage() ? <AccentsAndDialects></AccentsAndDialects> : shouldRedirectToSlash()
              }
            />
             <Route
              path="/culturenotes"
              exact={true}
              render={() => (performOnEveryPage() ? <CultureNotes></CultureNotes> : shouldRedirectToSlash())}
            />
            <Route
              path="/culturenotes/topic"
              exact={true}
              render={() => (performOnEveryPage() ? <CultureNotesTopic></CultureNotesTopic> : shouldRedirectToSlash())}
            />
             <Route
              path="/culturenotes/country"
              exact={true}
              render={() =>
                performOnEveryPage() ? <CultureNotesLocation></CultureNotesLocation> : shouldRedirectToSlash()
              }
            />
            <Route
              path="/emailtemplates"
              render={() => (performOnEveryPage() ? <EmailTemplates></EmailTemplates> : shouldRedirectToSlash())}
            />
            <Route
              path="/twt"
              render={() => (performOnEveryPage() ? <Twt></Twt> : shouldRedirectToSlash())}
            />
              <Route path="**" render={() => (performOnEveryPage() ? <PageNotFound /> : shouldRedirectToSlash())} />
              </Switch>
            </React.Fragment>
            }
            <Route path="**" render={() => (performOnEveryPage() ? <PageNotFound /> : shouldRedirectToSlash())} />
          </Switch>
          { window.location.pathname !== "/virtualclassroom" && <FooterComponentBlock /> }
        </div>
      </INTLProvider>
    </ThemeProvider>
  );
};

export default App;
